import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { vaySettings } from '../vay.config';

const LNG_KEY = 'lang';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language: any;
  selectedLanguage = new BehaviorSubject(null);
  availableLanguages = new BehaviorSubject(null);
  country = new BehaviorSubject(null);

  constructor(private translate: TranslateService) {}

  setInitialAppLanguage() {
    if (localStorage.getItem(LNG_KEY)) {
      this.setLanguage(localStorage.getItem(LNG_KEY));
      this.selectedLanguage.next(localStorage.getItem(LNG_KEY) as any);
    } else {
      this.language = vaySettings.info.defaultLang;
      this.setLanguage(this.language);
      this.translate.use(this.language);
      this.selectedLanguage.next(this.language);
      this.selectedLanguage.next(this.language);
      localStorage.setItem(LNG_KEY, this.language);
    }
  }

  getLanguages() {
    if (this.availableLanguages.value) {
      return (this.availableLanguages.value as any).map((lang: any) => {
        return { text: lang.name, value: lang.key.toLowerCase() };
      });
    } else {
      return [];
    }
  }

  getAllLanguages() {
    return [
      { text: 'English', value: 'en' },
      { text: 'Français', value: 'fr' },
      { text: 'العربية', value: 'ar' },
    ];
  }

  setLanguage(language: any) {
    if (language === 'ar') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
    this.translate.use(language);
    this.selectedLanguage.next(language);
    localStorage.setItem(LNG_KEY, language);
  }
}
